import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Checkbox,
  FormControlLabel,
  TextField,
  Radio,
  RadioGroup,
  FormControl,
  FormLabel,
  Tooltip,
  IconButton,
} from "@mui/material";
import MUIDataTable, { MUIDataTableOptions } from "mui-datatables";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { Box } from "@mui/material";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import API_BASE_URL from "../utilities/ApiConfig";
import formatDate from "../utilities/formatDate";
import editmodificationimg from "../assets/images/editmodificationimg.png";
import { faO } from "@fortawesome/free-solid-svg-icons";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";


const HighestSaleDeedTable = ( {data} ) => {
  const [openPopup, setOpenPopup] = useState(false);
  const { userDetails } = useSelector((state) => state.auth);
  console.log("user login data", userDetails);

  console.log(data);

  const navigate = useNavigate();

  const handleNavigateUpdatePages = (typeRecpt, regYear, vol, sr) => {
    debugger;
    let targetPage = "";

    if (typeRecpt.toLowerCase() === "search") {
      targetPage = "/SearchReceipt";
    } else if (typeRecpt.toLowerCase() === "copy") {
      targetPage = "/CopyReceipt";
    } else if (typeRecpt.toLowerCase() === "inspection") {
      targetPage = "/InspectionReceipt";
    } else if (typeRecpt.toLowerCase() === "commission") {
      targetPage = "/Commision";
    } else if (typeRecpt.toLowerCase() === "defeceit") {
      targetPage = "/DeficiateReceipt";
    } else if (typeRecpt.toLowerCase() === "others") {
      targetPage = "/Other";
    } else if (typeRecpt.toLowerCase() === "miscelleneous") {
      targetPage = "/NewReceipt";
    } else {
      toast.error("Invalid receipt type");
      return;
    }

    navigate(targetPage, {
      state: { regYear, vol, sr, typeRecpt, mod: true },
    });
  };

  const handleGetVoucherData = async () => {
    // try {
    //   const url = `${API_BASE_URL}/Accounts/get_voucher_details_by_voucher_id/${voucherId}`;
    //   const response = await axios.get(url);
    //   console.log('get data from the table', response.data);
    //   //   setVoucherData(response.data);
    //   //   setShowVoucher(true);
    // } catch (err) {
    //   toast.error("Failed to Load Expense Voucher.");
    // }
  };
  debugger
  const TableData = Array.isArray(data)
    ? data?.map((item, index) => ({
        ...item,
        sn: index + 1,
      }))
    : [];

  console.log(TableData);

  const columns = [

    {
      name: "dName",
      label: "District",
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value) => (
          <div className="text-center text-xs md:text-sm">{value}</div>
        ),
      },
    },
    {
      name: "sroName",
      label: "SRO",
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value) => (
          <div  style={{
            overflow: "hidden",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
            maxWidth: "120px", // Adjust as needed
          }} className="text-start text-xs md:text-xs 3xl:text-sm">{value}</div>
        ),
      },
    },
    {
      name: "deedType",
      label: "Deed Type",
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value) => (
          <div  style={{
            overflow: "hidden",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
            maxWidth: "120px", // Adjust as needed
          }} className="text-center text-xs md:text-sm">{value}</div>
        ),
      },
    },
    {
      name: "area",
      label: "Area1",
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value) => (
          <div className="text-start text-xs md:text-xs 3xl:text-sm">{value}</div>
        ),
      },
    },
    {
      name: "unit",
      label: "Unit",
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value) => (
          <div className="text-start text-xs md:text-xs 3xl:text-sm">{value}</div>
        ),
      },
    },
    {
      name: "location",
      label: "Location",
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value) => (
          <Tooltip title={value} arrow>
          <div
            style={{
              overflow: "hidden",
              whiteSpace: "nowrap",
              textOverflow: "ellipsis",
              maxWidth: "120px", // Adjust as needed
            }}
          >
            {value}
          </div>
        </Tooltip>
        ),
      },
    },
    {
      name: "stampDuty",
      label: "StampDuty",
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value) => (
          <div className="text-start text-xs md:text-xs 3xl:text-sm">{value}</div>
        ),
      },
    },
    {
      name: "transValue",
      label: "Trans Value",
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value) => (
          <div className="text-start text-xs md:text-xs 3xl:text-sm">{value}</div>
        ),
      },
    },
    {
      name: "mValue",
      label: "Market Value",
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value) => (
          <div className="text-start text-xs md:text-xs 3xl:text-sm">{value}</div>
        ),
      },
    },
    {
      name: "regDate",
      label: "Reg Date",
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value) => (
          <div className="text-start text-xs md:text-xs 3xl:text-sm">
            {formatDate(value, "dd/MM/yyyy")}
          </div>
        ),
      },
    },
    {
      name: "firstParty",
      label: "First Party",
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value) => (
          <Tooltip title={value} arrow>
          <div
            style={{
              overflow: "hidden",
              whiteSpace: "nowrap",
              textOverflow: "ellipsis",
              maxWidth: "120px", // Adjust as needed
            }}
          >
            {value}
          </div>
        </Tooltip>
        ),
      },
    },
    {
      name: "secondParty",
      label: "Second Party",
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value) => (
          <Tooltip title={value} arrow>
          <div
            style={{
              overflow: "hidden",
              whiteSpace: "nowrap",
              textOverflow: "ellipsis",
              maxWidth: "120px", // Adjust as needed
            }}
          >
            {value}
          </div>
        </Tooltip>
        ),
      },
    },
 
 
  ];

  const options = {
    selectableRows: "none",
    filterType: "dropdown",
    elevation: 0,
    rowsPerPageOptions: [10, 15, 25, 50],
    responsive: "standard",
    tableBodyHeight: "auto",
    tableBodyMaxHeight: "auto",
    download: true, 
    print: false,
    viewColumns: false, 
    search: false,
    filter: false,

  };
  
 
   const getMuiTheme = () =>
     createTheme({
       typography: {
         fontFamily: "Poppins",
       },
       palette: {
         background: {
           paper: "#ffffff",
           default: "#ffffff",
         },
         mode: "light",
       },
       components: {
        MuiTableCell: {
          styleOverrides: {
            head: {
              backgroundColor: "#CACACA !important",
              color: "#000000 !important",
              padding: "2px 1px",
              borderBottom: "2px solid #ECECEC",
              borderRight: "0px solid #ddd",
              fontSize: "12px", // Default font size
              textAlign: "start",
              whiteSpace: "nowrap", // Prevent text wrapping
              "@media (max-width: 768px)": {
                fontSize: "10px", // Reduce font size for small screens
              },
              "@media (max-width: 480px)": {
                fontSize: "8px", // Further reduce for extra small screens
              },
              "& .MuiTableSortLabel-root": {
                color: "#000000 !important",
                "&.MuiTableSortLabel-active": {
                  color: "#000000 !important",
                },
              },
              "& .MuiTableSortLabel-icon": {
                color: "#000000 !important",
              },
              "&:hover": {
                color: "#ffffff !important",
                backgroundColor: "#929292 !important",
              },
            },
            body: {
              padding: "3px 8px",
              color: "#000000",
              borderBottom: "1px solid #ECECEC",
              borderRight: "0px solid #000000",
            },
            footer: {
              padding: "7px 15px",
              borderBottom: "0px solid #ECECEC",
            },
          },
        },
        
         MuiInputBase: {
           styleOverrides: {
             root: {
               backgroundColor: "#F1F1F1", // Change search input background color
               borderRadius: "1px", // Optional: Add border-radius for better UI
               padding: "1px 5px",
               color: "#6A6A6A !important",
               borderBottom: "0px",
             },
           },
         },
       },
     });

  return (
    <>
      {/* {showVoucher && <VoucherPopup data={voucherData} attachmentData={attachmentData} openPopup={true} />}       */}
      <div className="py-2 flex">
        <Box width="100%">
          <ThemeProvider theme={getMuiTheme()}>
            <MUIDataTable
              data={TableData}
              columns={columns}
              options={options}
            />
          </ThemeProvider>
        </Box>
      </div>
    </>
  );
};

export default HighestSaleDeedTable;
